import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { StoryblokService } from './services/storyblok.service'
import { Components } from './components'
import { routeAnimations } from './animations/routerAnimations';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [routeAnimations]
})

export class AppComponent {
  title = 'ample';

  story = { content: null, name: '' }
  components = Components

  projects

  prepareRoute(outlet: RouterOutlet) {
    return outlet && outlet.activatedRouteData && outlet.activatedRouteData['animation'];
  }

  constructor(private storyBlokService: StoryblokService) {
    // window.storyblok.init()
    // window.storyblok.on(['change', 'published'], function() {
    //   location.reload(true)
    // })
  }

  // ngOnInit() {
  //   this.storyBlokService.getStory('home', {version: 'draft'}).then(data => {
  //     this.story = data.story
  //   })
  // }
}
